import { useCallback, useState } from 'react';
import { agentApi, type ToolInfo } from '../api/agent';

export interface UseAvailableTools {
  availableTools: ToolInfo[];
  toolsLoading: boolean;
  toolsError: string | null;
  loadAvailableTools: () => Promise<void>;
}

export function useAvailableTools(): UseAvailableTools {
  const [availableTools, setAvailableTools] = useState<ToolInfo[]>([]);
  const [toolsLoading, setToolsLoading] = useState(false);
  const [toolsError, setToolsError] = useState<string | null>(null);

  const loadAvailableTools = useCallback(async () => {
    try {
      setToolsLoading(true);
      setToolsError(null);
      const response = await agentApi.getTools();
      setAvailableTools(response.tools);
    } catch (err) {
      console.error('Failed to load tools:', err);
      setToolsError('도구 목록을 불러오지 못했습니다');
      setAvailableTools([]);
    } finally {
      setToolsLoading(false);
    }
  }, []);

  return { availableTools, toolsLoading, toolsError, loadAvailableTools };
}
